module.exports = __webpack_public_path__ + "media/images/favicon/rotpunkt_favicon-7e9220fe900ca56b9fe9fa6595ac6431.png";